import {observer} from 'mobx-react';
import React, {useEffect} from 'react';
import {MouldingCustomization} from '../../../i';
import ReactDOMServer from 'react-dom/server';
import RecycledIcon from './recycled-icon';
import s from '../../../s';
import * as util from '../../../../util';

declare const bootstrap: any;

const ALPHABETIZE_ENABLED = false;

type MouldingsListProps = {
    collapsed: boolean;
    selectedFinish: string;
    collapsedNumber: number;
    save: (id: number) => void;
    isModal?: boolean;
    showNames: boolean;
};

export const MouldingsList = observer((props: MouldingsListProps) => {
    const {isModal, collapsed, selectedFinish, collapsedNumber, showNames, save} = props;

    useEffect(() => {
        const popoverTriggerList = [].slice.call(document.querySelectorAll('[data-bs-toggle="popover"]'));
        const popoverList = popoverTriggerList.map(function (popoverTriggerEl: any) {
            return new bootstrap.Popover(popoverTriggerEl);
        });
    }, []);

    const filtered = s.prod.IsCAF ? s.prod.mouldings.filter(x => selectedFinish === '-1' || x.fpc_name === selectedFinish) : s.prod.mouldings;
    const hasFastShip = s.__fast_ship_orig && s.isRetail && filtered.some(m => s.prod.MouldingID === m.id);
    const originalMoulding = filtered.find(m => m.isBase);
    let trendingMouldings = filtered.filter(m => m.IsTrending);

    let trendingMoulding: MouldingCustomization | undefined;

    if (s.PortalID > 1) {
        trendingMouldings = [];
    }

    if (!hasFastShip && trendingMouldings.length > 0) {
        trendingMoulding = trendingMouldings.sort((a, b) => {
            const aScore = a.Customizations365 ?? -1;
            const bScore = b.Customizations365 ?? -1;

            if (aScore !== bScore) return bScore - aScore;

            return a.name.localeCompare(b.name);
        })[0];
    }

    if(s.PortalID > 0){
        trendingMoulding = undefined;
    }

    const remaining = filtered.filter(m => m !== originalMoulding && m !== trendingMoulding).filter((m, index, self) => index === self.findIndex(other => other.id === m.id));
    const trendingRemaining = ALPHABETIZE_ENABLED ? [...remaining].sort((a, b) => a.name.localeCompare(b.name)) : remaining;
    const sortedMouldings = [...(originalMoulding ? [originalMoulding] : []), ...(trendingMoulding && trendingMoulding.id !== s.prod.MouldingID ? [trendingMoulding] : []), ...trendingRemaining].slice(0, 1000).slice(0, collapsedNumber);

    return (
        <div
            className="moulding-prod"
            role="listbox"
            aria-label="Select frame mouldings"
            style={{justifyContent: isModal ? 'space-around' : ''}}
        >
            {/* .sort((a, b) => collapsed ? a.id === s.pcs.moulding_id ? -1 : b.id === s.pcs.moulding_id ? 1 : 0 : 1) */}
            {sortedMouldings.map((m: MouldingCustomization, i: number) => (
                <div
                    data-bs-toggle={window.innerWidth > 1200 ? 'popover' : ''}
                    data-bs-placement="top"
                    data-bs-html="true"
                    data-bs-trigger="hover focus"
                    data-bs-content={`<div class="prod-img-zoom"><img loading="lazy" src="https://${s.Portal.CDNDomain}/images/entities/moulding/${m.th5 ? `${m.id}_th5` : `${m.name.toLowerCase()}_thumb_270`}.png" alt="" />${
                        m.IsRecycled
                            ? ReactDOMServer.renderToStaticMarkup(
                                  <RecycledIcon
                                      width={90}
                                      top={'45%'}
                                      left={'70px'}
                                  />,
                              )
                            : ''
                    }</div>`}
                    id={`moulding-${m.id}`}
                    key={m.id}
                    title={m.title}
                    aria-label={`Select ${m.title} moulding`}
                    className={`cust-entity${s.pcs.moulding_id === m.id ? ' active' : ''}${!collapsed ? ' active-bold' : ''}`}
                    onClick={() => save(m.id)}
                    onKeyDown={e => {
                        if (e.key === 'Enter' || e.key === ' ') {
                            e.preventDefault();
                            save(m.id);
                        }
                    }}
                    data-img={`https://${s.Portal.CDNDomain}/images/entities/moulding/${m.name.toLowerCase()}_thumb_270.png`}
                    role="option"
                    tabIndex={0}
                >
                    <div style={{position: 'relative'}}>
                        <picture>
                            <source
                                type="image/webp"
                                srcSet={util.webp(`https://${s.Portal.CDNDomain}/images/entities/moulding/${m.name.toLowerCase()}_thumb_90.png`)}
                            />
                            <img
                                className="moulding-img"
                                data-img={`https://${s.Portal.CDNDomain}/images/entities/moulding/${m.name.toLowerCase()}_thumb_270.png`}
                                loading="lazy"
                                src={`https://${s.Portal.CDNDomain}/images/entities/moulding/${m.name.toLowerCase()}_thumb_90.png`}
                                alt={m.title}
                                height={70}
                                width={70}
                            />
                        </picture>

                        {m.IsRecycled != undefined && m.IsRecycled && (
                            <RecycledIcon
                                width={20}
                                top={'10px'}
                                left={'10px'}
                            />
                        )}

                        {showNames && <div>{m.title}</div>}
                    </div>

                    {s.__fast_ship_orig && s.isRetail && s.prod.MouldingID === m.id && (
                        <div className={`prod-fast-shipping fast-shipping-${s.PortalID}`}>
                            <i className={s.PortalID !== 3 ? `fas fa-shipping-fast` : `fas fa-cart-shopping-fast`}></i>
                        </div>
                    )}

                    {!hasFastShip && m === trendingMoulding && m.id !== s.prod.MouldingID && (
                        <div className="prod-moulding-trending" aria-label='Trending'>
                            <i className="fa-regular fa-fire-flame-curved"></i>
                            <span>Trending</span>
                        </div>
                    )}
                </div>
            ))}
        </div>
    );
});
